  // ...existing code...
import React, { useState, useEffect } from 'react';
import {
  Container,
  Typography,
  Box,
  Paper,
  List,
  ListItem,
  ListItemIcon,
  ListItemText,
  Chip,
  Divider,
  Alert,
  Button,
  Card,
  CardContent,
  Grid,
  Tabs,
  Tab,
  IconButton,
  Tooltip
} from '@mui/material';
import NotificationsIcon from '@mui/icons-material/Notifications';
import WarningIcon from '@mui/icons-material/Warning';
import ErrorIcon from '@mui/icons-material/Error';
import InfoIcon from '@mui/icons-material/Info';
import PersonIcon from '@mui/icons-material/Person';
import TimerIcon from '@mui/icons-material/Timer';
import PhoneIcon from '@mui/icons-material/Phone';
import SchoolIcon from '@mui/icons-material/School';
import PeopleIcon from '@mui/icons-material/People';
import CheckCircleIcon from '@mui/icons-material/CheckCircle';
import EventIcon from '@mui/icons-material/Event';
// import RefreshIcon from '@mui/icons-material/Refresh';
import api from '../axios';
import AppLayout from '../components/AppLayout';
import { useNavigate } from 'react-router-dom';
import Footer from '../components/Footer';

const Notificacoes = ({ onLogout }) => {
    // Limpar todas as notificações (admin)
    const limparTodas = async () => {
      try {
        await api.delete('/notificacoes');
        fetchNotificacoes();
      } catch (error) {
        setError('Erro ao limpar notificações');
      }
    };
  const [notificacoes, setNotificacoes] = useState([]);
  const [stats, setStats] = useState({ total: 0, nao_lidas: 0 });
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState('');
  const [userType, setUserType] = useState('');
  const isAdmin = userType === 'admin' || userType === 'admin_tenant';
  const [tabValue, setTabValue] = useState(0); // 0=Todas, 1=Professores, 2=Consolidação
  const navigate = useNavigate();

  useEffect(() => {
    // Determinar tipo de usuário
    const token = localStorage.getItem('token');
    if (token) {
      const payload = JSON.parse(atob(token.split('.')[1]));
      setUserType(payload.tipo);
    }
    
    fetchNotificacoes();
  }, []);

  const fetchNotificacoes = async () => {
    try {
      const token = localStorage.getItem('token');
      if (!token) return;

      const payload = JSON.parse(atob(token.split('.')[1]));
      const tipo = payload.tipo;

      let response;
      
      if (tipo === 'consolidador') {
        // Buscar consolidador pelo email
        const consResponse = await api.get('/consolidadores/', {
          params: { ativo: true }
        });
        const consolidador = consResponse.data.find(c => c.email === payload.sub);
        
        if (consolidador) {
          response = await api.get(`/notificacoes/consolidador/${consolidador.id}`);
        }
      } else if (tipo === 'admin' || tipo === 'admin_tenant') {
        response = await api.get('/notificacoes/admin');
      }

      if (response) {
        setNotificacoes(response.data.notificacoes);
        setStats({
          total: response.data.total,
          nao_lidas: response.data.nao_lidas
        });
      }
    } catch (error) {
      console.error('Erro ao buscar notificações:', error);
      setError('Erro ao carregar notificações');
    } finally {
      setLoading(false);
    }
  };

  const getIconByPriority = (prioridade) => {
    switch (prioridade) {
      case 'alta':
        return <ErrorIcon color="error" />;
      case 'media':
        return <WarningIcon color="warning" />;
      default:
        return <InfoIcon color="info" />;
    }
  };

  const getColorByPriority = (prioridade) => {
    switch (prioridade) {
      case 'alta':
        return 'error';
      case 'media':
        return 'warning';
      default:
        return 'info';
    }
  };

  const formatarTempo = (horas) => {
    if (horas < 0) {
      const horasAbs = Math.abs(horas);
      if (horasAbs >= 24) {
        const dias = Math.floor(horasAbs / 24);
        return `${dias} dia${dias > 1 ? 's' : ''} atrasado`;
      }
      return `${horasAbs}h atrasado`;
    }
    return `${horas}h restantes`;
  };

  // Marcar notificação de professor como lida
  const marcarComoLida = async (notifId) => {
    try {
      // Extrair ID real (remover prefixo prof_)
      const realId = notifId.replace('prof_', '');
      await api.put(`/notificacoes/${realId}/marcar-lida`);
      fetchNotificacoes(); // Recarregar
    } catch (error) {
      console.error('Erro ao marcar como lida:', error);
    }
  };

  // Marcar todas as notificações de professores como lidas
  const marcarTodasLidas = async () => {
    try {
      await api.put('/notificacoes/marcar-todas-lidas');
      fetchNotificacoes(); // Recarregar
    } catch (error) {
      console.error('Erro ao marcar todas como lidas:', error);
    }
  };

  // Filtrar notificações por categoria (tab)
  const getNotificacoesFiltradas = () => {
    if (tabValue === 0) return notificacoes; // Todas
    if (tabValue === 1) return notificacoes.filter(n => n.categoria === 'professores');
    if (tabValue === 2) return notificacoes.filter(n => n.categoria === 'consolidacao');
    return notificacoes;
  };

  const notifFiltradas = getNotificacoesFiltradas();

  return (
    <>
      <AppLayout>
      <Container maxWidth="lg" sx={{ py: { xs: 2, md: 4 }, px: { xs: 1, md: 2 } }}>
        <Box display="flex" alignItems="center" gap={2} mb={3} flexDirection={{ xs: 'column', md: 'row' }}>
          <NotificationsIcon sx={{ fontSize: 40, color: 'primary.main' }} />
          <Typography variant="h4" sx={{ fontSize: { xs: '1.2rem', md: '1.5rem' } }}>
            Notificações
          </Typography>
          {stats.total > 0 && (
            <Chip
              label={`${stats.nao_lidas} não lidas`}
              color="error"
              size="small"
            />
          )}
        </Box>

        {error && (
          <Alert severity="error" sx={{ mb: 2 }} onClose={() => setError('')}>
            {error}
          </Alert>
        )}

        {/* Cards de Resumo */}
        <Grid container spacing={2} sx={{ mb: 3 }}>
          <Grid item xs={12} md={6}>
            <Card>
              <CardContent>
                <Box display="flex" alignItems="center" justifyContent="space-between">
                  <Box>
                    <Typography color="text.secondary" variant="caption">
                      Total de Notificações
                    </Typography>
                    <Typography variant="h4" sx={{ fontSize: '4.4rem', lineHeight: 1 }}>{stats.total}</Typography>
                  </Box>
                  <NotificationsIcon sx={{ fontSize: 48, color: 'primary.main' }} />
                </Box>
              </CardContent>
            </Card>
          </Grid>
          <Grid item xs={12} md={6}>
            <Card>
              <CardContent>
                <Box display="flex" alignItems="center" justifyContent="space-between">
                  <Box>
                    <Typography color="text.secondary" variant="caption">
                      Não Lidas
                    </Typography>
                    <Typography variant="h4" color="error.main" sx={{ fontSize: '4.4rem', lineHeight: 1 }}>
                      {stats.nao_lidas}
                    </Typography>
                  </Box>
                  <WarningIcon sx={{ fontSize: 48, color: 'error.main' }} />
                </Box>
              </CardContent>
            </Card>
          </Grid>
        </Grid>

        {/* Tabs de Filtro (apenas para admin) */}
        {isAdmin && (
          <Paper sx={{ mb: 2 }}>
            <Tabs
              value={tabValue}
              onChange={(e, newValue) => setTabValue(newValue)}
              indicatorColor="primary"
              textColor="primary"
              centered
            >
              <Tab 
                label={`Todas (${notificacoes.length})`} 
                icon={<NotificationsIcon />}
                iconPosition="start"
              />
              <Tab 
                label={`Professores (${notificacoes.filter(n => n.categoria === 'professores').length})`}
                icon={<SchoolIcon />}
                iconPosition="start"
              />
              <Tab 
                label={`Consolidação (${notificacoes.filter(n => n.categoria === 'consolidacao').length})`}
                icon={<PeopleIcon />}
                iconPosition="start"
              />
            </Tabs>
          </Paper>
        )}


        {/* Ações Rápidas (admin) */}
        {isAdmin && (
          <Box sx={{ mb: 2, display: 'flex', gap: 1, justifyContent: { xs: 'stretch', md: 'flex-end' }, flexWrap: 'wrap' }}>
            {notificacoes.filter(n => n.categoria === 'professores' && !n.lida).length > 0 && (
              <Button
                variant="outlined"
                size="small"
                startIcon={<CheckCircleIcon />}
                onClick={marcarTodasLidas}
              >
                Marcar Todas de Professores como Lidas
              </Button>
            )}
            {notificacoes.length > 0 && (
              <Button
                variant="contained"
                color="error"
                onClick={limparTodas}
              >
                Limpar todas as notificações
              </Button>
            )}
          </Box>
        )}

        {/* Lista de Notificações */}
        {loading ? (
          <Paper sx={{ p: 4, textAlign: 'center' }}>
            <Typography>Carregando notificações...</Typography>
          </Paper>
        ) : notifFiltradas.length === 0 ? (
          <Paper sx={{ p: 4, textAlign: 'center' }}>
            <NotificationsIcon sx={{ fontSize: 80, color: 'text.secondary', mb: 2 }} />
            <Typography variant="h6" color="text.secondary">
              Nenhuma notificação no momento
            </Typography>
            <Typography variant="body2" color="text.secondary" sx={{ mt: 1 }}>
              Você está em dia com seus contatos! 🎉
            </Typography>
          </Paper>
        ) : (
          <Paper>
            <List>
              {notifFiltradas.map((notif, index) => (
                <React.Fragment key={notif.id}>
                  <ListItem
                    sx={{
                      bgcolor: notif.prioridade === 'alta' ? 'error.lighter' : 'inherit',
                      '&:hover': { bgcolor: 'action.hover' },
                      position: 'relative'
                    }}
                  >
                    <ListItemIcon>
                      {/* Ícone especial para professores */}
                      {notif.categoria === 'professores' ? (
                        <SchoolIcon color={notif.tipo === 'aula_pega' ? 'success' : 'warning'} />
                      ) : (
                        getIconByPriority(notif.prioridade)
                      )}
                    </ListItemIcon>
                    <ListItemText
                      primary={
                        <Box display="flex" alignItems="center" gap={1} flexWrap="wrap">
                          <Typography variant="subtitle1" fontWeight="bold">
                            {notif.titulo}
                          </Typography>
                          <Chip
                            label={notif.prioridade}
                            size="small"
                            color={getColorByPriority(notif.prioridade)}
                          />
                          {/* Badge de categoria */}
                          {notif.categoria === 'professores' && (
                            <Chip
                              label="Professor"
                              size="small"
                              icon={<SchoolIcon />}
                              variant="outlined"
                              color="primary"
                            />
                          )}
                          {notif.categoria === 'consolidacao' && (
                            <Chip
                              label="Consolidação"
                              size="small"
                              icon={<PeopleIcon />}
                              variant="outlined"
                              color="secondary"
                            />
                          )}
                        </Box>
                      }
                      secondary={
                        <Box sx={{ mt: 1 }}>
                          <Typography variant="body2" color="text.secondary">
                            {notif.mensagem}
                          </Typography>
                          
                          {/* Detalhes específicos para consolidador */}
                          {userType === 'consolidador' && notif.visitante_telefone && (
                            <Box display="flex" alignItems="center" gap={1} sx={{ mt: 1 }}>
                              <PhoneIcon fontSize="small" color="action" />
                              <Typography variant="caption" color="text.secondary">
                                {notif.visitante_telefone}
                              </Typography>
                            </Box>
                          )}
                          
                          {/* Tempo restante/atrasado */}
                          {notif.horas_restantes !== undefined && (
                            <Box display="flex" alignItems="center" gap={1} sx={{ mt: 0.5 }}>
                              <TimerIcon fontSize="small" color="action" />
                              <Typography variant="caption" color="text.secondary">
                                {formatarTempo(notif.horas_restantes)}
                              </Typography>
                            </Box>
                          )}
                          
                          {/* Detalhes para admin */}
                          {isAdmin && notif.consolidador_nome && (
                            <Box display="flex" alignItems="center" gap={1} sx={{ mt: 1 }}>
                              <PersonIcon fontSize="small" color="action" />
                              <Typography variant="caption" color="text.secondary">
                                Consolidador: {notif.consolidador_nome}
                              </Typography>
                            </Box>
                          )}
                        </Box>
                      }
                      primaryTypographyProps={{ component: 'div' }}
                      secondaryTypographyProps={{ component: 'div' }}
                    />
                    
                    {/* Ações */}
                    <Box sx={{ display: 'flex', gap: 1, flexDirection: 'column', alignItems: 'flex-end' }}>
                      {/* Ação para consolidador */}
                      {userType === 'consolidador' && notif.visitante_id && (
                        <Button
                          size="small"
                          variant="contained"
                          onClick={() => navigate('/area-consolidador')}
                        >
                          Ver Detalhes
                        </Button>
                      )}
                      
                      {/* Ação para admin - consolidação */}
                      {isAdmin && notif.tipo === 'atraso_consolidador' && (
                        <Button
                          size="small"
                          variant="outlined"
                          onClick={() => navigate('/relatorios-consolidacao')}
                        >
                          Ver Relatório
                        </Button>
                      )}
                      
                      {/* Ação para admin - notificação de professor */}
                      {isAdmin && notif.categoria === 'professores' && (
                        <>
                          <Button
                            size="small"
                            variant="outlined"
                            startIcon={<EventIcon />}
                            onClick={() => navigate('/calendario-aulas')}
                          >
                            Ver Calendário
                          </Button>
                          {!notif.lida && (
                            <Tooltip title="Marcar como lida">
                              <IconButton
                                size="small"
                                color="primary"
                                onClick={() => marcarComoLida(notif.id)}
                              >
                                <CheckCircleIcon />
                              </IconButton>
                            </Tooltip>
                          )}
                        </>
                      )}
                    </Box>
                  </ListItem>
                  {index < notifFiltradas.length - 1 && <Divider />}
                </React.Fragment>
              ))}
            </List>
          </Paper>
        )}

        <Box display="flex" justifyContent="center" gap={2} mt={3} flexWrap="wrap">
          <Button
            variant="outlined"
            onClick={fetchNotificacoes}
          >
            Atualizar
          </Button>
          {userType === 'consolidador' && (
            <Button
              variant="contained"
              onClick={() => window.location.href = '/area-consolidador'}
            >
              Ir para Área do Consolidador
            </Button>
          )}
          {isAdmin && (
            <>
              <Button
                variant="contained"
                onClick={() => navigate('/relatorios-consolidacao')}
              >
                Relatórios de Consolidação
              </Button>
              <Button
                variant="contained"
                color="secondary"
                startIcon={<EventIcon />}
                onClick={() => navigate('/calendario-aulas')}
              >
                Calendário de Aulas
              </Button>
            </>
          )}
        </Box>
      </Container>
      </AppLayout>
    </>
  );
};

export default Notificacoes;
